'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authInterceptor = authInterceptor;
function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
  'ngInject';

  var state;
  return {
    request: function request(config) {
      config.headers = config.headers || {};
      if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
        config.headers.Authorization = 'Bearer ' + $cookies.get('token');
      }
      return config;
    },
    responseError: function responseError(response) {
      if (response.status === 401) {
        (state || (state = $injector.get('$state'))).go('main');

        $cookies.remove('token');
      }
      return $q.reject(response);
    }
  };
}


// WEBPACK FOOTER //
// ./client/components/auth/interceptor.service.js